import * as React from 'react';

import { MRT_Row } from 'material-react-table';

import { Box, Typography } from '@mui/material';

import { RowData } from './types/propertyAlertTriggerRowData';
import { MobileListCard } from '../shared/mobile-list-card';

export const PropertyAlertTriggerCardView = ({
  row,
}: {
  row: MRT_Row<RowData>;
}) => {
  const enabled = row.original.enabled;
  const types = row.original.entityTypes ?? [];
  const criteria = types.includes('Device')
    ? 'Any Device'
    : types.includes('Source')
      ? 'Any Source'
      : types.join(', ');

  const triggerCriteria = (
    <div
      style={{
        fontSize: 12,
        marginLeft: '5px',
        width: 'auto',
        display: 'inline-flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
      }}
    >
      {row.original.triggerCriteria?.map((type, index) => (
        <span
          style={{ marginRight: '10px' }}
          key={`${row.original.id}-${index}`}
        >
          {type}
        </span>
      ))}
    </div>
  );

  return (
    <MobileListCard
      contentSx={{
        color: (theme) =>
          enabled ? theme.palette.secondary.main : theme.palette.primary.main,
        fontStyle: enabled ? 'normal' : 'italic',
      }}
    >
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: enabled ? 800 : 400,
        }}
        component="div"
      >
        {row.original.name ?? 'Unnamed alert trigger'}
      </Typography>
      <Box sx={{ marginLeft: '5px' }}>
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: enabled ? 600 : 400,
            color: 'inherit',
          }}
          component="div"
        >
          Type:
          <span style={{ fontSize: 12, fontWeight: 400, marginLeft: '5px' }}>
            {criteria}
          </span>
        </Typography>
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: enabled ? 600 : 400,
            color: 'inherit',
          }}
          component="span"
        >
          Trigger:
          <span style={{ fontSize: 12, fontWeight: 400, marginLeft: '5px' }}>
            {triggerCriteria}
          </span>
        </Typography>
      </Box>
    </MobileListCard>
  );
};
